import { render, staticRenderFns } from "./ObaagestSaleInvoice.vue?vue&type=template&id=76077879&"
import script from "./ObaagestSaleInvoice.vue?vue&type=script&lang=js&"
export * from "./ObaagestSaleInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports